// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-primary {
  color: #fff;
  background-color: #8784ee;
  border-color: #4a5582;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 0.65;
}
button.close {
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.flex-h {
  display: flex;
  flex-direction: row;
}
.flex-v {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.nowrap {
  white-space: nowrap;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
h1 {
  font-size: 36px;
}
h3,
h1 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  margin-top: 20px;
  margin-bottom: 10px;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.pull-left {
  float: left !important;
}
.pull-right {
  float: right !important;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
a {
  color: #8784ee;
  text-decoration: none;
}
.layoutChooser-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0,0,0,0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0,0,0,0.175);
  box-shadow: 0 6px 12px rgba(0,0,0,0.175);
}
.layoutChooser {
  border: 1px solid rgba(77,99,110,0.81);
  border-radius: 8px;
  padding: 5px 0;
  position: absolute;
  z-index: 5000;
}
.layoutChooser .selectedBefore {
  background-color: #8784ee;
}
.layoutChooser table {
  margin: 0 auto;
  border-spacing: 0;
  border-collapse: collapse;
}
.layoutChooser table td {
  cursor: pointer;
}
.layoutChooser table td:hover,
.layoutChooser table td.hover {
  background-color: #8784ee;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/common/button.styl","webpack://./../../ui/src/components/layoutButton/LayoutChooser.styl","webpack://./../../ui/src/components/common/global.styl"],"names":[],"mappings":"AAAA;EACE,WAAO;EACP,yBAAkB;EAClB,qBAAc;ACChB;ADCA;EACE,WAAO;EACP,yBAAkB;EAClB,qBAAc;ACChB;ADCA;EACE,WAAO;EACP,sBAAkB;EAClB,kBAAc;ACChB;ADCA;EACE,qBAAS;EACT,iBAAS;EACT,gBAAe;EACf,eAAW;EACX,gBAAa;EACb,uBAAa;EACb,kBAAY;EACZ,mBAAa;EACb,sBAAgB;EAChB,8BAAkB;EAClB,0BAAc;EACd,eAAQ;EACR,yBAAqB;EACrB,sBAAkB;EAClB,qBAAiB;EACjB,iBAAa;EACb,sBAAkB;EAClB,6BAAQ;EACR,kBAAe;ACCjB;ADCA;;;EACE,mBAAQ;EACR,wBAAoB;EACpB,gBAAY;EACZ,aAAS;ACGX;ADDA;EACE,wBAAoB;EACpB,UAAS;EACT,eAAQ;EACR,eAAY;EACZ,SAAQ;ACGV;ADDA;;EACE,kBAAU;EACV,qBAAS;EACT,sBAAgB;ACIlB;ADFA;EACE,uBAAS;EACT,mBAAW;EACX,gBAAa;EACb,qBAAe;ACIjB;AC9DA;EACE,8BAAoB;EACpB,2BAAiB;EACjB,sBAAY;ADgEd;AC9DA;EACE,WAAO;ADgET;AC9DA;EACE,YAAQ;ADgEV;AC9DA;EACE,aAAS;EACT,mBAAgB;ADgElB;AC9DA;EACE,aAAS;EACT,sBAAgB;ADgElB;AC9DA;EACE,YAAW;ADgEb;AC9DA;EACE,mBAAa;ADgEf;AC9DA;EACE,iBAAY;ADgEd;AC9DA;EACE,kBAAY;ADgEd;AC9DA;EACE,gBAAY;ADgEd;AC9DA;EACE,eAAW;ADgEb;AC9DA;;EACE,oBAAa;EACb,gBAAa;EACb,gBAAa;EACb,gBAAY;EACZ,mBAAe;ADiEjB;AC/DA;;;;EACE,oBAAa;EACb,kBAAW;EACX,oBAAa;ADoEf;AClEA;EACE,mBAAc;EACd,kBAAa;ADoEf;AClEA;EACE,sBAAO;ADoET;AClEA;EACE,uBAAO;ADoET;AClEA;EACE,UAAS;EACT,wCAAoB;EACpB,mCAAe;EACf,gCAAY;ADoEd;AClEA;EACE,UAAS;ADoEX;AClEA;EACE,cAAO;EACP,qBAAiB;ADoEnB;AArIA;EACE,kBAAU;EACV,SAAK;EACL,OAAM;EACN,aAAS;EACT,aAAS;EACT,WAAO;EACP,gBAAW;EACX,cAAS;EACT,eAAQ;EACR,eAAW;EACX,gBAAY;EACZ,gBAAY;EACZ,sBAAkB;EAClB,oCAAyB;EACzB,4BAAiB;EACjB,sBAAQ;EACR,kCAAQ;EACR,kBAAe;EACf,gDAAoB;EACpB,wCAAY;AAuId;AArIA;EAIE,sCAAQ;EACR,kBAAe;EACf,cAAS;EACT,kBAAU;EACV,aAAS;AAoIX;AA3IE;EACE,yBAAkB;AA6ItB;AArIE;EACE,cAAQ;EACR,iBAAgB;EAChB,yBAAiB;AAuIrB;AAtII;EACE,eAAQ;AAwId;AArIM;;EACE,yBAAkB;AAwI1B","sourcesContent":[".btn-danger\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n\n.btn-primary\n  color: #fff;\n  background-color: #8784EE;\n  border-color: #4A5582;\n\n.btn-default\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n\n.btn\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n\n.btn.disabled, .btn[disabled], fieldset[disabled] .btn\n  cursor: not-allowed;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  opacity: .65;\n\nbutton.close\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n\n.btn-group, .btn-group-vertical\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n\n.btn-sm\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  line-height: 1.5;\n  border-radius: .2rem;\n","@import '../common/button.styl'\n@import '../common/global.styl'\n\n$borderColor = rgba(77, 99, 110, 0.81)\n\n.layoutChooser-dropdown-menu\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0,0,0,.15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);\n  box-shadow: 0 6px 12px rgba(0,0,0,.175);\n\n.layoutChooser\n  .selectedBefore\n    background-color: #8784EE\n\n  border: 1px solid $borderColor;\n  border-radius: 8px\n  padding: 5px 0;\n  position: absolute;\n  z-index: 5000\n\n  table\n    margin: 0 auto\n    border-spacing: 0;\n    border-collapse: collapse;\n    td\n      cursor: pointer\n      transition(background-color 0.1s ease)\n\n      &:hover, &.hover // Add the hover class here to be triggered by mouseenter/mouseleave\n        background-color: #8784EE\n","*\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n.full-width\n  width: 100%\n\n.full-height\n  height: 100%\n\n.flex-h\n  display: flex\n  flex-direction: row\n\n.flex-v\n  display: flex\n  flex-direction: column\n\n.flex-grow\n  flex-grow: 1\n\n.nowrap\n  white-space: nowrap\n\n.text-right\n  text-align: right;\n\n.text-center\n  text-align: center;\n\n.text-left\n  text-align: left;\n\nh1\n  font-size: 36px;\n\nh3, h1\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n\nbutton, input, select, textarea\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n\n.row\n  margin-right: -15px;\n  margin-left: -15px;\n\n.pull-left\n  float: left!important;\n\n.pull-right\n  float: right!important;\n\n.fade\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n  -o-transition: opacity .15s linear;\n  transition: opacity .15s linear;\n\n.fade.in\n  opacity: 1;\n\na\n  color: #8784EE;\n  text-decoration: none;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
